import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  WhitelistSegmentStateType,
  WhitelistSegmentActiveSegmentType,
  SetWhitelistSegmentsPayloadActionType,
  SetDeleteTargetPayloadActionType,
  SetWhitelistSegmentQueryPayloadActionType,
  SetWhitelistSegmentModalPayloadActionType,
  SetWhitelistSegmentFormsPayloadActionType,
} from 'features/Segmentation/@types/WhitelistSegment'

export const SLICE_NAME = 'segmentation/whitelistSegment'

const initialState: WhitelistSegmentStateType = {
  isLoading: [],
  whitelistSegments: [],
  query: {
    search: '',
    page_size: 10,
    page_index: 1,
    cursor: '',
    direction: 'next',
    next_cursor: '',
    previous_cursor: '',
    next_page_exist: false,
    previous_page_exist: false,
  },
  modal: {
    mode: '',
  },
  deleteTarget: null,
  forms: {
    customerId: null,
    phoneNumber: '',
    targetedUsers: [],
    selectedUser: null,
    allSegments: [],
    segmentSearch: '',
    selectedSegments: [],
  },
}

const whitelistSegmentSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.isLoading.push(true)
      } else {
        state.isLoading.pop()
      }
    },
    setWhitelistSegments: (state, action: PayloadAction<SetWhitelistSegmentsPayloadActionType>) => {
      state.whitelistSegments = action.payload
    },
    removeWhitelistSegmentById: (state, action: PayloadAction<number>) => {
      state.whitelistSegments = state.whitelistSegments.filter(
        (item) => item.customer_id !== action.payload,
      )
    },
    setQuery: (state, action: PayloadAction<SetWhitelistSegmentQueryPayloadActionType>) => {
      state.query = { ...state.query, ...action.payload }
    },
    resetQuery: (state) => {
      state.query = initialState.query
    },
    setModal: (state, action: PayloadAction<SetWhitelistSegmentModalPayloadActionType>) => {
      state.modal = { ...state.modal, ...action.payload }
    },
    setDeleteTarget: (state, action: PayloadAction<SetDeleteTargetPayloadActionType>) => {
      state.deleteTarget = action.payload
    },
    setForms: (state, action: PayloadAction<SetWhitelistSegmentFormsPayloadActionType>) => {
      state.forms = { ...state.forms, ...action.payload }
    },
    toggleSelectedSegment: (state, action: PayloadAction<WhitelistSegmentActiveSegmentType>) => {
      const segment = action.payload
      state.forms.selectedSegments = state.forms.selectedSegments.some(
        (item) => item.id === segment.id,
      )
        ? state.forms.selectedSegments.filter((item) => item.id !== segment.id)
        : [...state.forms.selectedSegments, segment]
    },
    resetForms: (state) => {
      state.forms = initialState.forms
    },
  },
})

export const {
  reset,
  setIsLoading,
  setWhitelistSegments,
  removeWhitelistSegmentById,
  setQuery,
  resetQuery,
  setModal,
  setDeleteTarget,
  setForms,
  toggleSelectedSegment,
  resetForms,
} = whitelistSegmentSlice.actions
export default whitelistSegmentSlice.reducer
